export default __webpack_public_path__ + "static/media/Gebauer-Medium.42acf89c.otf";